module.exports = [
  {
    name: 'demo8',
    script: 'node_modules/next/dist/bin/next',
    args: 'start',
    instance: 'max',
    exec_mode: 'cluster',
    env: { PORT: 3000, NEXT_PUBLIC_FRONTEND: 'demo8' },
  },
  {
    name: 'demo-uk',
    script: 'node_modules/next/dist/bin/next',
    args: 'start',
    instance: 'max',
    exec_mode: 'cluster',
    env: { PORT: 3005, NEXT_PUBLIC_FRONTEND: 'demo-uk' },
  },
  {
    name: 'demo-de',
    script: 'node_modules/next/dist/bin/next',
    args: 'start',
    instance: 'max',
    exec_mode: 'cluster',
    env: { PORT: 3013, NEXT_PUBLIC_FRONTEND: 'demo-de' },
  },
  {
    name: 'demo-ml',
    script: 'node_modules/next/dist/bin/next',
    args: 'start',
    instance: 'max',
    exec_mode: 'cluster',
    env: { PORT: 3012, NEXT_PUBLIC_FRONTEND: 'demo-ml' },
  },
  {
    name: 'test-site',
    script: 'node_modules/next/dist/bin/next',
    args: 'start',
    instance: 'max',
    exec_mode: 'cluster',
    env: { PORT: 3750 },
  },
  {
    name: 'main-uk',
    script: 'node_modules/next/dist/bin/next',
    args: 'start',
    instance: 'max',
    exec_mode: 'cluster',
    env: { PORT: 3752, NEXT_PUBLIC_FRONTEND: 'main-uk' },
  },
  {
    name: 'main-de',
    script: 'node_modules/next/dist/bin/next',
    args: 'start',
    instance: 'max',
    exec_mode: 'cluster',
    env: { PORT: 3753, NEXT_PUBLIC_FRONTEND: 'main-de' },
  },
  {
    name: 'main-ml',
    script: 'node_modules/next/dist/bin/next',
    args: 'start',
    instance: 'max',
    exec_mode: 'cluster',
    env: { PORT: 3754, NEXT_PUBLIC_FRONTEND: 'main-ml' },
  },
];
